import { takeLatest, put } from 'redux-saga/effects';
import { fetchValuationHistory, appNotify, setIsFetchingValuationHistory } from 'store/actions';
import { getWithToken } from 'api/network';

export function* getValuationHistorySaga() {
  yield takeLatest(fetchValuationHistory, function* ({ payload }) {
    const { transactionOpportunityId, callback } = payload;
    try {
      yield put(setIsFetchingValuationHistory(true));
      const res = yield getWithToken(`/api/underwrite/prop/${transactionOpportunityId}/valuationHistory`);
      const response = yield res.json();
      const opps = response.length > 0 ? response : []; // return empty array if no opps found

      if (callback) {
        yield callback(opps);
      }
    } catch (error) {
      console.log('error', error.message);
      yield put(appNotify(error.message, 'error'));
    }
    finally {
      yield put(setIsFetchingValuationHistory(false));
    }
  });
}